import React from "react";
import { Button, Form } from "semantic-ui-react";
import { Field, reduxForm } from "redux-form";
import { LOADING } from "../utils/helpers/phases";

const ChangePasswordComponent = ({ handleSubmit, phase, isDemo, t }) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Field
        name="oldPassword"
        type="password"
        disabled={isDemo}
        component={Form.Input}
        fluid
        icon="lock"
        iconPosition="left"
        label={t("changePassword:currentPasswordText")}
        placeholder={t("changePassword:currentPasswordText")}
      />
      <Field
        name="password"
        type="password"
        disabled={isDemo}
        component={Form.Input}
        fluid
        icon="lock"
        iconPosition="left"
        label={t("changePassword:newPasswordText")}
        placeholder={t("changePassword:newPasswordText")}
      />
      <Field
        name="confirmpassword"
        type="password"
        disabled={isDemo}
        component={Form.Input}
        fluid
        icon="lock"
        iconPosition="left"
        label={t("changePassword:confirmNewPasswordText")}
        placeholder={t("changePassword:confirmNewPasswordText")}
      />
      <Button
        type="submit"
        color="blue"
        loading={phase === LOADING}
        disabled={phase === LOADING || isDemo}>
        {t("changePassword:changePasswordText")}
      </Button>
    </Form>
  );
};

export default reduxForm({
  form: "change-password"
})(ChangePasswordComponent);



// WEBPACK FOOTER //
// ./src/components/ChangePasswordComponent.js